import React from 'react';
import './Event_about.css';

const Event_about = () => {
    const state = {
        FourKeys_item: [
            {
                title: 'Start a career in QA',
                topics: [
                    'Fundamentals of Testing',
                    'Test Techniques',
                    'Test Tool Selection and Metrics',
                    'Pros and Cons of Implementing Testing',
                    'Business Value of Testing',
                ],
            },
            {
                title: 'Growing to Senior',
                topics: [
                    'Test Planning, Monitoring and Control',
                    'Evaluating Exit Criteria and Reporting',
                    'Test Closure Activities',
                    'Risk-Based Testing and Other Approaches for Test Prioritization and Effort Allocation',
                    'Test Documentation and Other Work Products',
                    'Test Estimation',
                ],
            },
            {
                title: 'Test Management Skills',
                topics: [
                    'Test Management in Context',
                    'Management Reviews and Audits',
                    'Test Improvement Process',
                    'People Management Skills – Teams and Communications',
                    'Defining and Using Test Metrics',
                    'Assessing Process Capability with Defect Report Information',
                ],
            },
        ],
    };

    const renderGetReady = (item, i) => {
        return (
            <div className="getReady_item" key={`getReady_item-${i}`}>
                <div className='getReady_item--title_block'>
                    <h3 className='getReady_item--title'>{item.title}</h3>
                </div>
                <ul className='getReady_ul'>
                    {item.topics.map(item => <li className='getReady_li' key={`getReady_li-${i + item}`}><span>[]</span> {item}</li>)}
                </ul>
            </div>
        );
    };

    return (
        <div className='getReady_wrap'>
            <div className='container getReady'>
                <h2 className='getReady_title colorful'>What event is about</h2>
                <div className='getReady_block'>
                    {state.FourKeys_item.map((item, i) => renderGetReady(item, i))}
                </div>
            </div>
        </div>
    );
};

export default Event_about;